module.exports = __webpack_public_path__ + "assets/img/oneExtract.df1b3037.png";